import React from "react";

export const Brand = ({ className = "h-20 sm:h-[120px]" }) => (
  <img
    src="/logo-light.png"
    alt="ListingPro - Professional Property Agent"
    className={`${className} w-auto rounded-xl bg-white p-1.5 shadow-lg shadow-black/30 object-contain shrink-0`}
    data-testid="brand-logo-img"
  />
);

export const SiteFooter = ({ className = "" }) => (
  <footer className={`px-4 py-6 border-t border-white/5 text-center text-xs text-slate-500 ${className}`} data-testid="site-footer">
    @2026 MasSoegeng - @ListingPro
  </footer>
);
